import { SA_CHARGE_PRODUCTS } from '../../../constants/selfActivationProducts';
import { getDeviceSn } from '../../../utils/helpers';
import { getPlanAmountFromName } from '../../../utils/plans';

export const getPlanVariants = (subsList) => {
  let planVariants = [];
  let unlimVariants = [];
  let parkingVariants = [];
  let newLinePlanVariants = [];

  subsList.forEach((sub) => {
    const data = getPlanAmountFromName(sub.variant_title);
    let variant = {
      name: sub.variant_title,
      deviceSn: getDeviceSn(sub.properties),
      data,
    };
    let variants;
    switch (data) {
      case 'Unlimited': {
        variants = unlimVariants;
        variant.type = 'unlimited';
        break;
      }
      case 'Parking': {
        variants = parkingVariants;
        variant.type = 'parking';
        break;
      }
      case 'New Line': {
        variants = newLinePlanVariants;
        variant.type = 'new_line';
        break;
      }
      default: {
        variants = planVariants;
        variant.type = 'per_gb';
      }
    }

    if (
      variant.deviceSn ||
      !variants.find((variant) => variant.name === sub.variant_title)
    ) {
      variants.push(variant);
    }
  });

  planVariants.sort((a, b) => {
    if (a.data < b.data) {
      return -1;
    }
    if (a.data > b.data) {
      return 1;
    }
    return 0;
  });

  return {
    planVariants: [...planVariants, ...unlimVariants, ...parkingVariants],
    newLinePlanVariants,
  };
};

export const getAccountNotEligibleForSelfActivation = (charges) => {
  if (!charges) {
    return false;
  }

  const failedCharges = charges.filter((charge) => charge.status === 'error');
  const blockingCharge = failedCharges.find((charge) =>
    charge.line_items.find(
      (lineItem) =>
        !SA_CHARGE_PRODUCTS.includes(lineItem.external_product_id?.ecommerce),
    ),
  );

  return blockingCharge ? true : false;
};
